/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  let flkty = null;
  let flktyOptions = {
    cellAlign: 'center',
    contain: true,
    fade: true,
    pageDots: true,
    draggable: false,
  };
  // enable prev/next buttons at 768px
  if (matchMedia('screen and (max-width: 768px)').matches) {
    const elem = document.querySelector('.main-carousel');
    flkty = new Flickity(elem, flktyOptions);

    flkty.on('change', function (index) {
      layerButtons.find((button, i) => {
        if (i === index) {
          button.classList.add('selected');
        } else {
          button.classList.remove('selected');
        }
      });
    });
  }

  // Add custom code below this line
  let accordionItems = [...document.querySelectorAll('.mattress-layers__inner__content__item--desktop')].map(
    (item, i) => {
      return {
        index: i,
        element: item,
      };
    }
  );

  let currentIndex = 0;

  const autoPlay = () => {
    let newIndex = currentIndex < accordionItems.length - 1 ? currentIndex + 1 : 0;
    setIsActive(newIndex);
  };

  const setIsActive = (index) => {
    let tl = gsap.timeline({
      defaults: { duration: 0.5, ease: 'power2.inOut' },
    });
    currentIndex = index;
    accordionItems.forEach((item) => {
      let content = item.element.querySelector('.mattress-layers__inner__content__item__text__content');
      tl.set(content, { height: '0px', display: 'block', opacity: 0 }, '<');
      if (item.index === currentIndex) {
        tl.to(content, { display: 'block', opacity: 1, duration: 0.5 }, '<');
        tl.to(content, { height: 'auto', duration: 0.5 }, '<');
        item.element.classList.add('active');
        if (flkty) {
          flkty.select(currentIndex);
        }
        layerButtons.find((button, i) => {
          if (i === currentIndex) {
            button.classList.add('selected');
          } else {
            button.classList.remove('selected');
          }
        });
      } else {
        item.element.classList.remove('active');
        tl.to(content, { height: '0px', duration: 0.5 }, '<');
        tl.set(content, { display: 'none', opacity: 0 }, '<');
      }
    });
  };

  let handleClick = (e, index) => {
    if (flkty) {
      flkty.stopPlayer(); // Stop Flickity autoPlay when user clicks
    } else {
      stopAutoPlay(); // Stop autoPlay when user clicks
    }
    setIsActive(index);
  };

  let layerButtons = [...document.querySelectorAll('.layer-button')].map((button, i) => {
    button.addEventListener('click', handleClick.bind(null, null, i));
    return button;
  });

  accordionItems.forEach((item) => {
    setIsActive(0); // Initialize the first item as active
    item.element.addEventListener('click', handleClick.bind(null, null, item.index));
  });

  let autoPlayInterval = null;
  let isAutoplaying = false;
  const startAutoPlay = () => {
    if (isAutoplaying) return; // Prevent multiple intervals
    isAutoplaying = true;
    autoPlayInterval = setInterval(() => {
      autoPlay();
    }, 4000);
  };
  const stopAutoPlay = () => {
    if (!isAutoplaying) return; // Prevent stopping if not autoplaying
    isAutoplaying = false;
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const snapSection = document.querySelector('.snap-section');
    const snapSections = [...snapSection.querySelectorAll('.snap-section__child')];

    // create
    let mm = gsap.matchMedia();
    let breakPoint = 768; // Set your breakpoint here
    // add a media query. When it matches, the associated function will run
    mm.add(
      {
        // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint - 1}px)`,
        reduceMotion: '(prefers-reduced-motion: reduce)',
      },
      (context) => {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;
        if (isDesktop && flkty) {
          // If on desktop and Flickity is initialized, destroy it
          flkty.destroy();
          flkty = null;
        }

        if (isMobile && !flkty) {
          // If on mobile and Flickity is not initialized, initialize it
          stopAutoPlay(); // Stop autoPlay if it was running
          const elem = document.querySelector('.main-carousel');
          flkty = new Flickity(elem, flktyOptions);
          flkty.on('change', function (index) {
            layerButtons.find((button, i) => {
              if (i === index) {
                button.classList.add('selected');
              } else {
                button.classList.remove('selected');
              }
            });
          });
        }
        const accordionCount = accordionItems.length;
        const layerButtons = [...document.querySelectorAll('.layer-button')].filter((button, i) => {
          return i < accordionCount;
        });
        const onCompleteCallback = () => {
          const grandchildrenImages = snapSection.querySelectorAll('[data-image-index]');
          // console.dir(grandchildrenImages);
          // console.log(timeline);
          if (isDesktop) {
            startAutoPlay(); // Start autoPlay only on desktop
          } else if (flkty) {
            flkty.playPlayer('2000');
          }
          // layerButtons.forEach((button) => {
          //   let imageIndex = button.getAttribute('data-button-index');
          //   let imageRect = grandchildrenImages[imageIndex].getBoundingClientRect();
          //   console.dir(imageIndex);
          //   console.dir(imageRect);
          //   gsap.set(button, { y: `${imageRect.bottom}px` });
          // });
        };
        const timelines = snapSections.map((section, i) => {
          const tl = gsap.timeline({
            defaults: { duration: 0.75, ease: 'power2.inOut', delay: 0.15 },
            paused: true,
          });

          layerButtons.forEach((button) => {
            tl.set(button, { opacity: 0, display: 'none' }, '<');
          });
          const child = section.querySelector('.snap-section__child--combined > img');
          const grandchildrenContainer = section.querySelector('.snap-section__child--combined__grandchildren');
          tl.to(section, {
            top: isDesktop ? (i === 0 ? '10%' : i === 1 ? `45%` : `70%`) : i === 0 ? '25%' : i === 1 ? `50%` : `70%`,
            opacity: 1,
            delay: 0,
          });
          if (grandchildrenContainer) {
            const grandchildren = [...grandchildrenContainer.querySelectorAll('.snap-section__grandchild')];
            tl.to(child, { opacity: 0, display: 'none', duration: 0.5 });
            tl.to(
              grandchildrenContainer,
              {
                display: 'block',
                delay: 0,
              },
              '<'
            );
            grandchildren.forEach((grandchild, i) => {
              tl.to(
                grandchild,
                {
                  opacity: 1,
                  top: isDesktop ? (i === 0 ? '-20%' : `20%`) : i === 0 ? '-15%' : `15%`,
                  delay: 0,
                },

                '<'
              );
            });
            tl.to(layerButtons, {
              opacity: 1,
              display: 'block',
              stagger: 0.2,
              duration: 0.5,
            });
          }
          return tl;
        });

        // Create a ScrollTrigger instance for the snapSection container
        ScrollTrigger.create({
          trigger: snapSection,
          start: 'top bottom+=200px',
          end: 'bottom top-=200px',
          onToggle: (self) => {
            isUnstacked = self.isActive;
            if (self.isActive) {
              timelines.forEach((tl, i) => {
                tl.play();
                if (i === timelines.length - 1) {
                  tl.eventCallback('onComplete', onCompleteCallback, [tl, i]);
                }
              });
            }
          },
        });
      }
    );

    return () => {
      // optional
      // custom cleanup code here (runs when it STOPS matching)
    };
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
